import React from 'react';

const HotelAgencyInvoice = () => {
  return (
    <div>
      <h1>HotelAgencyInvoice</h1>
    </div>
  );
};

export default HotelAgencyInvoice;
